import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage} from '../../../../services/helpers.js';
import DelayedRedirect from '../../../../utils/DelayedRedirect';
import { Transition } from '../../../../utils/ModalHelpers';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment';
import { SelectTheme } from '../../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import appFetch from '../../../../api/appFetch.js';
import { AbsenceTypesUrl } from '../../../../constants/apiUrls.js';

export default class AbsenceTypeNew extends Component {
    constructor(props) {
        super(props);

        this.state = {         
            description: "",
            isActive: false,
            requestInProgress: false,
            redirect: null,
            open: true,
            absenceTypeWasCreated:false,
        };
    }

    componentDidMount() {
        this.setState({ redirect: null });
    }

    isValidForm = () => {
        const { description } = this.state;

        if(!description || description.trim().length === 0){
            return false;
        }

        return true;
    }

    handleClose = () => {
        this.setState({ open: false, redirect: "/absencetypes" });
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value.replace(/^\s+/, "") });
    };

    handleChangeCheckBox = e => {
        this.setState({ [e.target.name]: e.target.checked });
    };

    handleSubmit = () => {
        this.saveNewAbsenceType();
    }

    saveNewAbsenceType = () => {
        let resources = this.props.resources;
        if (this.state.description.trim().length <= 0) {
            DisplayMessage(resources["InvalidDescripton"], "error");
            return;
        }

        this.setState({ requestInProgress: true });

        var json = JSON.stringify({
            description: this.state.description != "" ? this.state.description : null,          
            isActive: this.state.isActive,
        });

        const url = AbsenceTypesUrl();

        appFetch({
            url: url,
            method: 'POST',
            body: json,
            onSuccess: (data) => {
                DisplayMessage(resources["NewAbsenceTypeCreated"], "success");
                this.setState({ absenceTypeWasCreated: true, redirect:"/absencetypes" });
            },
            onError: (data) => {
                for (var i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }
   
    renderForm() {
        const handleSubmit = (event) => {
            event.preventDefault();
            event.stopPropagation();
        };

        const { isActive, description } = this.state;

        var resources = this.props.resources;
     
        var helperTextDescription = description.trim().length <= 0 ? "helper-text-red": "helper-text-grey";
     
        return (
            <Paper elevation={3} className="p-4 mt-3 mb-3">
                <Form onSubmit={handleSubmit} >
                    <Form.Group className="pt-3 d-flex"  >
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className={"col-6 " + helperTextDescription} id="absencetype-description" value={description} label={resources["Description"]}                                
                                helperText={resources["InputOfDescriptionIsMandatory"]}
                                variant="outlined" name="description" onChange={this.handleChange} inputProps={{ maxLength: 100 }} />
                        </ThemeProvider >
                    </Form.Group>               
                  
                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="absencetype-is-active" checked={isActive} onChange={this.handleChangeCheckBox} name="isActive" color="primary" />}
                            label={resources["IsActive"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>
                </Form>
            </Paper>
        );
    }

    renderMain() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>);
        }

        return <div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')} style={{ textAlign: "center" }}>
            {this.renderForm()}
        </div>;
    }

    render() {
        const {  open,  requestInProgress, redirect ,absenceTypeWasCreated} = this.state;
        const { resources } = this.props;

        const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect
        
        return (
            <div>
                {redirect && <DelayedRedirect to={{ pathname: redirect,state: { refreshGrid: absenceTypeWasCreated} }} delay={250} />}
                <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
                    <AppBar className="position-sticky">
                        <Toolbar>
                            <IconButton id="close-add-absencetype" edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {resources["AddNewAbsenceType"]}
                            </Typography>
                            <Button id="absencetype-save" color="inherit" disabled={isSaveButtonDisabled} onClick={this.handleSubmit}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>
                    <div className="container">
                        {this.renderMain()}
                    </div>
                </Dialog>
            </div >
        );
    }
}